import React from 'react'
import Header from '../component/layout/Header'
import Footer from '../component/layout/Footer'
import Profile from "../component/User/Profile/Profile.jsx"
const ProfilePage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);
  return (
<>
<Header activeLink='profile'/>
<Profile/>
<Footer/>
</>
  )
}

export default ProfilePage